import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {FeatureSelectItem} from './featureSelectItem';
import {widgetButton} from '../../css/styleSets';

@customElement('feature-compact-select-item')
export class FeatureCompactSelectItem extends FeatureSelectItem {

	static styles = [
		widgetButton,
		css`
			:host {
				flex-grow: 1;
				display: contents;
			}

			.item {
				position: relative;
				margin-bottom: 0;
				width: auto;
				flex-grow: 1;
			}
			.hidden {
				display: none;
			}
		`];

	render() {
		return html`
			<div class="item ${classMap({
				selected: this.isIncluded(),
				disabled: !this.canBeIncluded(),
				fixed: !this.canBeExcluded(),
				hidden: !this.isVisible()
			})}">
				<button @click="${this.toggleDecision}">
					<trans-label key="${this.feature.variableId}" value="${this.featureValue.featureValueId}" context="FV"></trans-label>
				</button>
				${when(this.getInfoText() !== '', () => html`
					<div class="hoverinfo">
						<div class="content">
							${this.getInfoText()}
						</div>
					</div>
				`)}

			</div>
		`;
	}
}
